import { render } from "./LayoutLanding.vue?vue&type=template&id=24804e73&ts=true"
import script from "./LayoutLanding.vue?vue&type=script&lang=ts"
export * from "./LayoutLanding.vue?vue&type=script&lang=ts"

import "./LayoutLanding.vue?vue&type=style&index=0&id=24804e73&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__